import React from "react";
import { Row, Col } from "react-bootstrap";

const CardData = (props) => {
  const { title, reading, unit, bgColour, colour, icon, addUnit } = props;

  return (
    <div
      className={`tw-font-nunito tw-text-center tw-py-3 tw-m-2 sm:tw-w-44 tw-w-2/5 
      tw-rounded-md tw-shadow-md ${bgColour} tw-text-${colour}`}
    >
      <Row className="tw-flex tw-justify-around tw-items-center">
        <Col xs={5} className="sm:tw-text-xl tw-text-lg tw-font-bold">
          {title}
        </Col>
        <Col xs={4}>
          <i className={`${icon} fa-lg`}></i>
        </Col>
      </Row>
      <p className="sm:tw-text-3xl tw-text-2xl tw-mb-0">
        {reading} {unit} <small className="tw-text-sm">{addUnit}</small>
      </p>
      {/* <p
        className={`tw-text-lg tw-font-bold ${
          reading > 3 ? "tw-text-green-600" : "tw-text-red-600"
        }`}
      >
        {reading > 3 ? "NORMAL" : "WARNING"}
      </p> */}
    </div>
  );
};

export default CardData;
